module.exports = __webpack_public_path__ + "media/images/front/materiales_sup_m-6e7282c02d54e90a0f611947e95ef1dd.webp";